import type {NotificationFragment} from "app/gql/graphqlSchema";
import {create as zustandCreate} from "zustand";
import {immer} from "zustand/middleware/immer";
import {type Loadable, LOADING_STATE_NA} from "app/state/common/loadable";
import type {Updater} from "use-immer";

export interface EmployeeNotificationState {
  notifications: Loadable<NotificationFragment[]>;
  setNotifications: Updater<Loadable<NotificationFragment[]>>;
  refreshCount: number;
  lastDismissedAtSeconds: number;
  setLastDismissedAtSeconds: (data: number) => void;
}

export const useEmployeeNotificationState = zustandCreate(
  immer<EmployeeNotificationState>((setState) => ({
    notifications: LOADING_STATE_NA,
    setNotifications: (arg) =>
      setState((state) => {
        if (typeof arg === "function") {
          const ret = arg(state.notifications);
          if (ret !== undefined) {
            state.notifications = ret;
          }
        } else {
          state.notifications = arg;
        }
        state.refreshCount++;
      }),
    refreshCount: 0,
    lastDismissedAtSeconds: 0,
    setLastDismissedAtSeconds: (data) =>
      setState((state) => {
        state.lastDismissedAtSeconds = data;
      })
  }))
);
